import type { BarProps } from '@/components/atomic/atoms/navigation/bar/typings';
import type { BasicComponentProps } from '@/typings/generic';
import styled, { CSSObject } from '@emotion/styled';

const Bar = styled.span<BarProps & BasicComponentProps>(
	({ theme, $position, $open }) => {
		const style: CSSObject = {
			backgroundColor: theme.colors.primaryBrandColor,
			width: 14,
			height: 2,
			position: 'absolute',
			opacity: 1,
			transition:
				'bottom 0.3s ease, top 0.3s ease, transform 0.3s ease, opacity 0.3s ease',
			transformOrigin: 'center',
			transitionDelay: $open ? '0.3s' : '0s',
			[theme.media.desktop.sm]: {
				width: 24,
				height: 3.43,
			},
		};

		if ($position === 'top') style.top = 0;
		if ($position === 'bottom') style.bottom = 0;
		if ($position === 'middle') {
			style.top = '50%';
			style.transform = 'translateY(-50%)';
		}

		if ($open) {
			if ($position === 'top') {
				style.transform = 'rotate(45deg)';
			}
			if ($position === 'middle') {
				style.opacity = 0;
			}
			if ($position === 'bottom') {
				style.transform = 'rotate(-45deg)';
			}
		}

		return style;
	},
);

export default Bar;
